import Header from 'components/Pathway/Header/Header'
import Projects from 'components/Pathway/Projects/Projects'
import Account from 'components/shared/Account/Account'
import BlockToText from 'components/shared/BlockToText/BlockToText'
import { themeClassName } from 'helpers/Project'
import { signposting } from 'helpers/blockToTextSlice'
import PropTypes from 'prop-types'

import './Pathway.scss'

const Pathway = ({ pathway, projects, locale, theme, user }) => {
  const blockToTextSlice = signposting(pathway.slug)

  return (
    <div className={`${themeClassName(theme)}`}>
      <div className="c-pathway-header__white">
        <Header locale={locale} pathway={pathway} />
      </div>
      {blockToTextSlice && (
        <BlockToText gtmLabel={blockToTextSlice?.gtmLabel} />
      )}
      <div className="c-pathway-projects">
        {!user && (
          <div className="c-pathway-account">
            <Account locale={locale} />
          </div>
        )}
        {projects &&
          Object.keys(projects).length !== 0 &&
          projects.entities.length !== 0 && (
            <Projects
              locale={locale}
              projects={projects.entities}
              steps={pathway?.included?.step}
              ordered={pathway.ordered}
            />
          )}
      </div>
    </div>
  )
}

Pathway.propTypes = {
  pathway: PropTypes.object.isRequired,
  projects: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  theme: PropTypes.string,
  user: PropTypes.object,
}

export default Pathway
